<template>
  <div class="carousel-container" @mouseenter="stopAutoPlay" @mouseleave="startAutoPlay">
    <div class="swiper-wrapper">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="swiper-slide swiper-no-swiping"
        :class="{
          'swiper-slide-prev': index === getPrevIndex(),
          'swiper-slide-active': index === currentIndex,
          'swiper-slide-next': index === getNextIndex()
        }"
        :style="{
          backgroundImage: `url(${image})`,
          transitionDuration: '0ms',
          zIndex: getZIndex(index)
        }"
      >
        <div class="maidian">
          <div :class="`img img-${images.length - index}`">
            <div :class="`tag tag${images.length - index}`"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prev" @click="prev" />
    <div class="next" @click="next" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  images: {
    type: Array as PropType<string[]>,
    required: true
  },
  interval: {
    type: Number,
    default: 5000
  }
})

const currentIndex = ref(0)
let timer: number

const next = () => {
  currentIndex.value = (currentIndex.value + 1) % props.images.length
}

const prev = () => {
  currentIndex.value = (currentIndex.value - 1 + props.images.length) % props.images.length
}

const getPrevIndex = () => {
  return (currentIndex.value - 1 + props.images.length) % props.images.length
}

const getNextIndex = () => {
  return (currentIndex.value + 1) % props.images.length
}

const getZIndex = (index: number) => {
  const diff = index - currentIndex.value
  const imagesLength = props.images.length
  if (diff === 0) {
    return 1
  } else if (diff === 1 || diff === -imagesLength + 1) {
    return 0
  } else if (diff === -1 || diff === imagesLength - 1) {
    return 0
  } else {
    return -Math.abs(diff)
  }
}

const startAutoPlay = () => {
  timer = window.setInterval(next, props.interval)
}

const stopAutoPlay = () => {
  clearInterval(timer)
}

onMounted(() => {
  startAutoPlay()
})

onBeforeUnmount(() => {
  stopAutoPlay()
})
</script>

<style lang="scss" scoped>
.carousel-container {
  position: relative;
  width: 1440px;
  height: 600px; /* 根据需求调整高度 */
  margin: 0 auto;
}

.swiper-wrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  perspective: 1000px; /* 设置透视效果 */
}

.swiper-slide {
  position: absolute;
  width: 1020px;
  height: 100%;
  margin: 0 auto;
  border-radius: 14px;
  background-size: cover;
  background-position: center;
  transition:
    transform 0.5s ease-in-out,
    z-index 0.5s ease-in-out;
}

.swiper-slide-prev {
  transform: scale(0.65) translateX(-70%) translate3d(300px, 0px, -150px) rotateX(0deg) rotateY(35deg);
}

.swiper-slide-active {
  transform: scale(1) translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg);
}

.swiper-slide-next {
  transform: scale(0.65) translateX(70%) translate3d(-300px, 0px, -150px) rotateX(0deg) rotateY(-35deg);
}

.prev,
.next {
  z-index: 999;
  width: 80px;
  height: 80px;
  position: absolute;
  top: 50%;
  border: none;
  cursor: pointer;
  font-size: 2rem;
  background: url('/images/home/arrow.png');
  background-size: 100%;

  &:hover {
    background: url('/images/home/arrowHighlight.png');
    background-size: 100%;
  }
}

.prev {
  left: 110px;
  transform: translateX(-150%) translateY(-50%) rotate(90deg);
}

.next {
  right: 110px;
  transform: translateX(150%) translateY(-50%) rotate(-90deg);
}
</style>
